// extracted by mini-css-extract-plugin
export default {"container":"q5Uds","promo":"T7z9Z","actualPrice":"KIkOH","expiredPrice":"bSEDs","discount":"dW3QK","uzb":"TAf8L","mini":"fxA6s","longPrice":"xcbBV","expiredSpace":"z9dcN"};